const SearchOrderForm = ({ toggleFilters }) => {
  return (
    <>
      {toggleFilters && (
        <>
          <div className="rounded bg-gray p-3">
            <div className="row">
              <div className="col-lg-3 form-group">
                <label for="searchcolumns" className="form-label fw-bolder">
                  Search By
                </label>
                <select
                  name="searchcolumns"
                  id="searchcolumns"
                  className="submit_on_change form-control form-control"
                >
                  <option value="ID">Invoice#</option>
                  <option value="date">Date</option>
                  <option value="ordered_by">Order By</option>
                  <option value="description">Description</option>
                  <option value="updated_at">Update Time</option>
                </select>
              </div>
              <div className="col-lg-3 form-group">
                <label for="search_value" className="form-label fw-bolder">
                  Search
                </label>
                <input
                  type="text"
                  name="search_value"
                  id="search_value"
                  className="form-control"
                />
              </div>
              <div className="col-lg-3 form-group">
                <label for="orderby" className="form-label fw-bolder">
                  Order By
                </label>
                <select
                  name="orderby"
                  id="orderby"
                  className="submit_on_change form-control form-control"
                >
                  <option value="ID">Invoice#</option>
                  <option value="date">Date</option>
                  <option value="ordered_by">Order By</option>
                  <option value="description">Description</option>
                  <option value="updated_at">Update Time</option>
                </select>
              </div>
              <div className="col-lg-3 form-group">
                <label for="order" className="form-label fw-bolder">
                  Order
                </label>
                <select name="order" id="order" className="form-control">
                  <option value="ascending">Ascending</option>
                  <option value="descending">Descending</option>
                </select>
              </div>
              <div className="col-lg-3 form-group">
                <label for="start_date" className="form-label fw-bolder">
                  Start Date
                </label>
                <input
                  type="date"
                  name="start_date"
                  id="start_date"
                  className="form-control"
                />
              </div>
              <div className="col-lg-3 form-group">
                <label for="end_date" className="form-label fw-bolder">
                  End Date
                </label>
                <input
                  type="date"
                  name="end_date"
                  id="end_date"
                  className="form-control"
                />
              </div>
              <div className="clearboth"></div>
            </div>
            <div className="row">
              <div className="col-lg-12 pb-3">
                <input
                  type="submit"
                  className="btn site_btn text-white"
                  value="Search"
                />
                <a href="" className="btn site_btn text-white mx-3">
                  Reset
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SearchOrderForm;
